
import React, { useEffect, useState } from 'react';
import './VideoInstruction.css';
import { useNavigate, useParams } from 'react-router-dom';

const VideoInstruction = () => {
  const landscape = `${process.env.PUBLIC_URL}/inspection-icons/landscapeMode.svg`;
  const clock_icon = `${process.env.PUBLIC_URL}/custom-icons/intro.gif`;
  const navigate = useNavigate();
  const { audit_id } = useParams();

  // Initialize state based on window dimensions (Landscape or Portrait)
  const [isInLandscapeMode, setIsInLandscapeMode] = useState(
    window.innerWidth > window.innerHeight
  );

  useEffect(() => {
    // Function to update orientation
    const updateOrientation = () => {
      setIsInLandscapeMode(window.innerWidth > window.innerHeight);
    };

    // Add event listener to detect orientation change
    window.addEventListener('resize', updateOrientation);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', updateOrientation);
    };
  }, []);

  return (
    <>
      {!isInLandscapeMode ? (
        <div
          style={{
            opacity: '0.8',
            height: '100svh',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <img
            src={landscape}
            alt="Landscape GIF"
            style={{
              height: '4rem',
            }}
          />
          <h3
            style={{
              textAlign: 'center',
              marginBottom: '0.5rem',
              wordWrap: 'break-word',
            }}
          >
            Please rotate video to landscape
          </h3>
          <h6
            style={{
              padding: '0 1rem',
              textAlign: 'center',
              wordWrap: 'break-word',
            }}
          >
            Turn on auto-rotation as video needs to be captured in landscape
            mode.
          </h6>
        </div>
      ) : (
        <div className="container">
          <div className="video-example">
            {/* Video player element with controls */}
            <video className="video-player" controls>
              <source src={clock_icon} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="instructions">
            <h2 className="title">Video instruction</h2>
            <p className="sub-title">
              Inspection is finished. The next steps are:
            </p>
            <ul className="step-list">
              <li className="step">
                <div className="step-number">1</div>
                <p className="step-text">
                  Take video of front, sides and back of the car
                </p>
              </li>
              <li className="step">
                <div className="step-number">2</div>
                <p className="step-text">Take video of the odometer</p>
              </li>
              <li className="step">
                <div className="step-number">3</div>
                <p className="step-text">Take video of the chassis</p>
              </li>
            </ul>
            <button
              className="skip-button"
              onClick={() => navigate(`/video/${audit_id}`)}
            >
              Skip
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoInstruction;
